/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Header extends Component {
  // group header
  group = null;

  // student header
  person = null;

  // breadcrumb
  onBack = null;

  backLabel = null;
  middleLabel = null;
  onMiddle = null;
  middleRoute = null;

  @computed('group.bannerText', 'person.fullName')
  get title() {
    return this.person
      ? this.person.get('fullName')
      : this.group && this.group.get('bannerText');
  }

  @computed('group.staffNames', 'person.ribbonText')
  get subtitle() {
    return this.person
      ? this.person.get('ribbonText')
      : this.group && this.group.get('staffNames');
  }
}
